import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export function useReceiptVerification() {
  const [store, setStore] = useState(undefined); // undefined=checking, null=locked
  const [serial, setSerial] = useState("");
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.storeMe().then(setStore).catch(() => setStore(null));
  }, []);

  const logout = () => {
    api.storeLogout().catch((err) => console.warn("Logout sede non riuscito:", err));
    setStore(null);
    setReceipt(null);
    setError("");
  };

  const handleAuthError = (e) => {
    if (e?.response?.status === 401) {
      toast.error(e.response.data?.detail || "Sessione scaduta");
      logout();
      return true;
    }
    return false;
  };

  const run = async (fn, fallback) => {
    setBusy(true);
    try {
      return await fn();
    } catch (e) {
      if (!handleAuthError(e)) toast.error(e?.response?.data?.detail || fallback);
      return undefined;
    } finally {
      setBusy(false);
    }
  };

  const lookup = async (s) => {
    const val = (s ?? serial).trim().toUpperCase();
    if (!val) return toast.error("Inserisci o scansiona il seriale");
    setBusy(true);
    setError("");
    setReceipt(null);
    try {
      setReceipt(await api.getReceipt(val));
      setSerial(val);
    } catch (e) {
      if (!handleAuthError(e)) setError(e?.response?.data?.detail || "Ricevuta non trovata");
    } finally {
      setBusy(false);
    }
  };

  const reset = () => {
    setReceipt(null);
    setError("");
    setSerial("");
  };

  return { store, serial, setSerial, receipt, setReceipt, error, busy, logout, handleAuthError, run, lookup, reset };
}
